define.alias("shared/utils/number-helpers/format-number-with-suffix", "media/utils/number-helpers/format-number-with-suffix");